const hasFeature = key => auth => {
  return Boolean(auth.client.features.find(feature => feature.key === key));
};

export default hasFeature;
